import { render, staticRenderFns } from "./ProductEditStock.vue?vue&type=template&id=d767e166"
import script from "./ProductEditStock.vue?vue&type=script&lang=ts"
export * from "./ProductEditStock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports